// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1kFf0","buttons":"RemoveExpirationActionButtons_buttons__uX6bw"};